<div class="qa-page">
  <div class="qa-widget-frame">
    <div id="ulAiWidget"></div>
  </div>
</div>

